module.exports = __webpack_public_path__ + "img/Pag1.781bee62.png";